import React from 'react';
import { useState } from 'react';
import RecipeForm from './RecipeForm/RecipeForm';
import RecipeNavigator from './RecipeNavigator/RecipeNavigator';
import ErrorPage from "../ErrorPage";
import "./RecipePage.css"
import { useData } from "../DataContext/DataProvider"


function RecipePage() {
    const [inputRecipe, setInputRecipe] = useState({
        Recipe_ID: -2,
        Recipe_Name: "",
        Recipe_Time: 0,
        Recipe_Difficulty: 0,
        Recipe_Ingredients: [],
        Recipe_Instructions: []
    });
    
    const dataContext = useData();

    //only display list when server has been accessed, otherwise display error screen
    //todo split into error screen and loading screen
    if (dataContext.recipesData.serverAccess === 1) {
        return (
            <div className="recipe-page">
                <RecipeForm inputRecipe={inputRecipe} setInputRecipe={setInputRecipe}></RecipeForm>
                <div className={"navigator-container" + (inputRecipe.Recipe_ID !== -2 ? " hidden" : " visible")}>
                    <RecipeNavigator handleEditing={setInputRecipe} isEditable={true} ></RecipeNavigator>
                </div>
            </div>
        );
    }
    else
        return <ErrorPage serverAccessState={dataContext.recipesData.serverAccess}/>
}

export default RecipePage;